
import React from 'react'

export default function PolygonPurpleFilled() { return (<svg width="146" height="146" viewBox="0 0 146 146" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.88623 145.225L0.886224 2.05232L144.345 145.225L0.88623 145.225Z" fill="#9E19EF" stroke="#9E19EF"/>
</svg>)}
